import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice.ts";
import authenticateReducer from "./slices/authenticateSlice.ts";
import snackbarReducer from "./slices/snackbarSlice.ts";
import uploadsReducer from "./slices/uploadSlice.ts";
import uploadsResponseModalReducer from "./slices/uploadsResponseModalSlice.ts";
import calendarReducer from "./slices/calendarSlice.ts";
import sessionReducer from "./slices/sessionSlice.ts";
import eventReducer from "./slices/eventSlice.ts";
import bugReportModalReducer from "./slices/bugReportModalSlice.ts";
import settingsReducer from "./slices/settingsSlice.ts";
import fieldsReducer from "./slices/fieldsSlice.ts";
import logsReducer from "./slices/logsSlice.ts";
import miniNavReducer from "./slices/miniNavSlice.ts";
import searchReducer from "./slices/searchSlice.ts";
import schedulesReducer from "./slices/schedulesSlice.ts";
import schedulesSearchReducer from "./slices/schedulesSearchSlice.ts";
import reportsReducer from "./slices/reportsSlice.ts";
import pendingUploadsReducer from "./slices/pendingUploadsSlice.ts";
import regularSessionsReducer from "./slices/regularSessionsSlice.ts";
import personalsReducer from "./slices/personalsSlice.ts";
import potentialRegularSessionsReducer from "./slices/potentialRegularSessionsSlice.ts";
import surgeonBillingRulesReducer from "./slices/surgeonBillingRulesSlice.ts";

export const store = configureStore({
	reducer: {
		user: userReducer,
		authenticate: authenticateReducer,
		snackbar: snackbarReducer,
		uploads: uploadsReducer,
		uploadsResponseModal: uploadsResponseModalReducer,
		calendar: calendarReducer,
		session: sessionReducer,
		event: eventReducer,
		bugReportModal: bugReportModalReducer,
		settings: settingsReducer,
		fields: fieldsReducer,
		logs: logsReducer,
		miniNav: miniNavReducer,
		search: searchReducer,
		schedules: schedulesReducer,
		schedulesSearch: schedulesSearchReducer,
		reports: reportsReducer,
		pendingUploads: pendingUploadsReducer,
		regularSessions: regularSessionsReducer,
		personals: personalsReducer,
		potentialRegularSessions: potentialRegularSessionsReducer,
		surgeonBillingRules: surgeonBillingRulesReducer,
	},
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
